import { render, staticRenderFns } from "./UpsellProducts.vue?vue&type=template&id=228b4f0e"
import script from "./UpsellProducts.vue?vue&type=script&lang=js"
export * from "./UpsellProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports